const initialAnimateField = {
  initial: 'hidden',
  animate: 'visible',
}

export const springTransition = {
  type: "spring",
  stiffness: 500,
  damping: 30
};

export const Animations = {
  springTransition: {
    type: "spring",
    stiffness: 500,
    damping: 32,
  },

  fade: {
    variants: {
      hidden: { opacity: 0 },
      visible: { opacity: 1 },
    },
    transition: {
      duration: .4,
    },
    exit: {
      opacity: 0,
      transition: { duration: .4, },
    },
    ...initialAnimateField,
  },

  expandY: {
    variants: {
      hidden: { scaleY: 0 },
      visible: { scaleY: 1, transformOrigin: 'top' },
    },
    transition: {
      ease: "easeOut",
      duration: .4,
    },
    ...initialAnimateField,
  },

  flipX90: {
    variants: {
      hidden: { rotateX: 90, y: 20 },
      visible: { rotateX: 0, y: 0, transformOrigin: 'top' },
    },
    transition: {
      // ease: "easeOut",
      duration: .4,
      delay: .1,
    },
    ...initialAnimateField,
  },

  processing: {
    variants: {
      hidden: { opacity: 1 },
      visible: { opacity: 0.5, transition: { yoyo: Infinity } },
    },
    ...initialAnimateField,
  }
}